import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HeaderDown.css';

function HeaderDown() {
  const [search, setSearch] = useState('');

  return (
    <div className='headerdown'>
        <div className='headerdown__up'>
            <Link to='/all-toys'>
              <label className='flex_row_label'>ALL TOYS</label>
            </Link>
            <Link to='/best-sells'>
              <label className='flex_row_label'>BEST SELLS</label>
            </Link>
            <Link to='/more-recents'>
              <label className='flex_row_label'>MORE RECENTS</label>
            </Link>
            <Link to='/boys-toys'>
              <label className='flex_row_label'>BOYS TOYS</label>
            </Link>
            <Link to='/girls-toys'>
              <label className='flex_row_label'>GIRLS TOYS</label>
            </Link>
        </div>
        <div className='headerdown__down'>
            <input type="text" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} name="search"></input>
            <Link to={search ? `/search/${search}` : '/'}>
              <button type="submit">SEARCH</button>
            </Link>
        </div>
    </div>
  )
}

export default HeaderDown;